import { render, staticRenderFns } from "./StatsIcon.vue?vue&type=template&id=39115afc"
import script from "./StatsIcon.vue?vue&type=script&lang=js"
export * from "./StatsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports